import { jsxs as l, jsx as i } from "react/jsx-runtime";
import { useCallback as p } from "react";
import { useMultiStyleConfig as d, chakra as h, Divider as f, Text as u } from "@chakra-ui/react";
import "../../../icons/index.es.js";
import "../../../atoms/Button/Button.es.js";
import { useDropdownStyle as x } from "../../Dropdown/Dropdown.context.es.js";
import { DropdownItem as C } from "../../Dropdown/components/DropdownItem.es.js";
import "../../Dropdown/Dropdown.container.es.js";
const w = ({
  customActions: o = [],
  options: t = []
}) => {
  const m = x(), s = d("Autocomplete"), n = (t == null ? void 0 : t.length) > 0, c = p(
    ({ id: e, label: r, onActionClick: a }) => {
      a({ id: e, label: r });
    },
    [o]
  );
  return /* @__PURE__ */ l(h.div, { __css: m.actions, children: [
    n && /* @__PURE__ */ i(f, {}),
    o.map((e, r) => /* @__PURE__ */ l(
      C,
      {
        sx: s.action,
        onClick: () => c(e),
        children: [
          e.icon,
          /* @__PURE__ */ i(u, { as: "span", children: e.label })
        ]
      },
      r
    ))
  ] });
};
export {
  w as AutocompleteActions
};
//# sourceMappingURL=AutocompleteActions.es.js.map
